(function($) {
  var thumbsCarousels = document.querySelectorAll('.tour-carousel');
  Array.prototype.forEach.call( thumbsCarousels, el => {
    var $self = $(el);
    var main = $self.find('.tour-carousel__main').get(0);
    var thumbs = $self.find('.tour-carousel__thumbs').get(0);

    new Swiper(main, {
      loop: true,
      spaceBetween: 15,
      navigation: {
        prevEl: '.swiper-navigation-prev',
        nextEl: '.swiper-navigation-next'
      },
      thumbs: {
        swiper: {
          el: thumbs,
          loop: false,
          spaceBetween: 10,
          slidesPerView: 'auto',
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          slideToClickedSlide: true,
          slidesPerView: 4,
          freeMode: true,
          breakpointsInverse: true,
          breakpoints: {
            768: {
              slidesPerView: 5,
            },
            992: {
              slidesPerView: 6,
            }
          }
        }
      }
    })
  } );
})(jQuery);